<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseReservationRecordList.push"
    :is-show-administrator-select="true"
    :is-show-student-select="true"
    :is-show-reserve-state-select="true"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    administrator-select-label="操作管理员账号"
    student-select-label="学员账号"
    quick-time-tab-label="操作时间"
    reserve-state-select-label="预约状态"
    :is-show-group-count="true"
    group-count-label="同一学员最小记录数"
  >
    <v-column-time value="操作时间"/>

    <el-table-column label="操作管理员账号" width="140" align="">
      <template v-slot="{ row }">
        <v-avatar-nickname
          v-if="row.administrator_id"
          :value="row.administrator_avatar"
          :nickname="row.administrator_nickname"
          :is-center="false"
          :avatar-size="50"
        />
        <router-link v-else :to="RouteConfig.studentDetail.to(row.student_id)" class="primary-color">学员本人</router-link>
      </template>
    </el-table-column>

    <v-column-student label="学员账号" link-page-id="student_id"/>

    <el-table-column label="操作类型" width="130">
      <template v-slot="{ row }">
        {{ getReservationNameByState(row.reserve_state) }}
      </template>
    </el-table-column>

    <el-table-column label="课程名称" width="200">
      <template v-slot="{ row }">
        <router-link class="primary-color" :to="RouteConfig.courseManage.to(row.course_id)">{{ row.course_name }}</router-link>
      </template>
    </el-table-column>

    <el-table-column label="课程时间" width="210">
      <template v-slot="{ row }">
        {{ row.start_time | timeToYmdHi }} ~ {{ row.end_time | timeToHi}}
      </template>
    </el-table-column>

    <el-table-column label="课程门店" width="200">
      <template v-slot="{ row }">
        <template v-if="row.store_name">{{ row.store_name }}</template>
        <span v-else class="info-color">未知</span>
      </template>
    </el-table-column>

    <el-table-column label="课程老师" width="110">
      <template v-slot="{ row }">
        {{ row.teacher_names }}
      </template>
    </el-table-column>

    <el-table-column label="课卡信息">
      <template v-slot="{ row }">
        <template v-if="row.card_id || row.card_ticket_id">
          <template v-if="row.card_id">使用课卡：「<router-link :to="RouteConfig.cardDetail.to(row.card_id)" class="primary-color">{{ row.card_name }} No.{{row.card_id}}</router-link>」；</template>
          <template v-else>使用课次券：「<router-link :to="RouteConfig.cardTicketDetail.to(row.card_ticket_id)" class="primary-color">{{ row.card_ticket_type_name }} No.{{row.card_ticket_id}}</router-link>」；</template>
          <template v-if="row.is_number_limit || row.card_ticket_id">
            <template
              v-if="row.reserve_state === reserveStates.waitSignIn.value
              || row.reserve_state === reserveStates.signCanceled.value"
            >
              <template v-if="row.reserve_state === reserveStates.waitSignIn.value">
                预约扣次：「<span class="success-color">{{ row.decrement_number | toYuan }}</span> 次」；
              </template>
              <template v-else>
                返还次数：「<span class="success-color">{{ -row.decrement_number | toYuan }}</span> 次」；
              </template>

              剩余次数：「<span class="success-color">{{ row.expire_number | toYuan }}</span> 次」；
            </template>
          </template>
          <template v-else>
            剩余次数：「<span class="success-color">无限制</span>」；
            <template v-if="row.decrement_days">
              <template v-if="row.reserve_state === reserveStates.waitSignIn.value
              || row.reserve_state === reserveStates.signCanceled.value
              || row.reserve_state === reserveStates.signedIn.value">
                <template v-if="row.reserve_state === reserveStates.signCanceled.value">
                  返还天数：「<span class="success-color">{{ -row.decrement_days | toYuan }}</span> 天」；
                </template>
                <template v-else>
                  预约扣天：「<span class="success-color">{{ row.decrement_days | toYuan }}</span> 天」；
                </template>
              </template>

            </template>
          </template>
          <template v-if="row.add_time > 1704038400">
            过期时间：「<span class="success-color"><template v-if="row.expire_time">{{ row.expire_time | timeToYmdHi }}</template><template v-else>未开卡</template></span>」。
          </template>
        </template>
        <span v-else-if="row.we_chat_order_id" class="success-color">微信支付预约</span>
        <span v-else class="success-color">免费预约</span>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`reservation-record-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>操作时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>操作管理员账号</span>
              <v-avatar-nickname
                v-if="v.administrator_id"
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="false"
                :avatar-size="50"
              />
              <router-link v-else :to="RouteConfig.studentDetail.to(v.student_id)" class="primary-color">学员本人</router-link>
            </div>

            <div class="list-item-detail">
              <span>管理员昵称</span>
              <v-avatar-nickname
                :value="v.avatar"
                :nickname="v.nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>学员账号</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>操作类型</span>
              <span>{{ getReservationNameByState(v.reserve_state) }}</span>
            </div>

            <div class="list-item-detail">
              <span>课程名称</span>
              <router-link class="primary-color" :to="RouteConfig.courseManage.to(v.course_id)">{{ v.course_name }}</router-link>
            </div>

            <div class="list-item-detail">
              <span>课程时间</span>
              <span>{{ v.start_time | timeToYmdHi }} ~ {{ v.end_time | timeToHi}}</span>
            </div>

            <div class="list-item-detail">
              <span>课程门店</span>
              <template v-if="v.store_name">{{ v.store_name }}</template>
              <span v-else class="info-color">未知</span>
            </div>

            <div class="list-item-detail">
              <span>课程老师</span>
              <span>{{ v.teacher_names }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">课卡信息</span>
              <span class="list-item-info" v-if="v.card_id">
                使用课卡：「<router-link :to="RouteConfig.cardDetail.to(v.card_id)" class="primary-color">{{ v.card_name }} No.{{v.card_id}}</router-link>」；
                <template v-if="v.is_number_limit">
                  <template
                    v-if="v.reserve_state === reserveStates.waitSignIn.value
              || v.reserve_state === reserveStates.signCanceled.value"
                  >
                    <template v-if="v.reserve_state === reserveStates.waitSignIn.value">
                      预约扣次：「<span class="success-color">{{ v.decrement_number | toYuan }}</span> 次」；
                    </template>
                    <template v-else>
                      返还次数：「<span class="success-color">{{ -v.decrement_number | toYuan }}</span> 次」；
                    </template>

                    剩余次数：「<span class="success-color">{{ v.expire_number | toYuan }}</span> 次」；
                  </template>
                </template>
                <template v-else>
                  剩余次数：「<span class="success-color">无限制</span>」；
                  <template v-if="v.decrement_days">
                    <template v-if="v.reserve_state === reserveStates.waitSignIn.value
              || v.reserve_state === reserveStates.signCanceled.value
              || v.reserve_state === reserveStates.signedIn.value">
                      <template v-if="v.reserve_state === reserveStates.signCanceled.value">
                        返还天数：「<span class="success-color">{{ -v.decrement_days | toYuan }}</span> 天」；
                      </template>
                      <template v-else>
                        预约扣天：「<span class="success-color">{{ v.decrement_days | toYuan }}</span> 天」；
                      </template>
                    </template>

                  </template>
                </template>
                <template v-if="v.add_time > 1704038400">
                  过期时间：「<span class="success-color"><template v-if="v.expire_time">{{ v.expire_time | timeToYmdHi }}</template><template v-else>未开卡</template></span>」。
                </template>
              </span>
              <span v-else class="success-color">免费预约</span>
            </div>

            <div class="list-item-button"></div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>

</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { getLegalQueryList } from '@/utils/formats';
import { index } from '@/api/course-reservation-record';
import { getReservationNameByState, reserveStates } from "@/enums/reserveStates";

export default {
  name: RouteConfig.courseReservationRecordList.name,
  data: () => ({
    RouteConfig,
    reserveStates,
    isLoading: false,
    isStoringIds: [],
    isDeleting: {},
    count: 0,
    list: [],
    queryList: {},
  }),
  computed: {
    ...mapGetters([
      'defaultStoreId',
      'isAdministrator',
      'isMobile',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    getReservationNameByState,
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
